// 预约设置 - 渲染开关DOM配置文件 开关分类
export enum SwitchTypeEnum {
  IS_TURN_ON = 'isTurnOn',
  SWITCH_SETTING_EMAIL = 'isSettingEmail',
}

// 提交类型
export enum LeaveTypeEnum {
  /** 保存 */
  SAVE = 'save',
  /** 草稿 */
  DRAFT = 'draft',
  /** 发送邮件 */
  SEND_EMAIL = 'sendEmail',
  /** 默认 */
  DEFAULT = '',
}
